import { render, staticRenderFns } from "./editSplashscreen.vue?vue&type=template&id=d6dc97de&"
import script from "./editSplashscreen.vue?vue&type=script&lang=js&"
export * from "./editSplashscreen.vue?vue&type=script&lang=js&"
import style0 from "./editSplashscreen.vue?vue&type=style&index=0&id=d6dc97de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports